export const resetEvent = (state) => {
  state.status = '';
  state.error = '';
  state.events = [];
  state.eventsStatus = 'loading';
  state.eventsCurrency = '';
  state.eventStatus = 'loading';
  state.eventError = '';
  state.event = {};
  state.eventExpenses = {
    eventExpenses: {
      avg_expenses: 0,
      operations: [],
      total_expenses: 0,
    },
    status: 'loading',
    updateStatus: '',
    error: '',
  };
  state.moveTransactionError = '';
  state.currentEventId = 0;
  state.eventCurrency = '';
  state.eventIsOriginal = false;
  state.userToDelete = '';
  state.eventTransactions = [];
  state.eventTransactionsStatus = 'loading';
  state.updateTransactionsStatus = '';
  state.payouts = [];
  state.eventPayoutsStatus = 'loading';
  state.userPayoutsCurrency = '';
  state.payoutsActiveUser = {};
  state.userPayoutsStatus = '';
};
